const configBoardTemplate = {
    notice: {
        listLayout: 'BoardListDefaultLayout',
        paginationLayout: 'PaginationtDefaultLayout',
        filterLayout: 'BoardFilterDefaultLayout'
    },
    noticeCreate: {
        optionLayouts: ['BoardInputLayout'],
    },
    noticeUpdate: {
        optionLayouts: ['BoardInputLayout'],
    },

    faq: {
        listLayout: 'BoardListFaqLayout',
        paginationLayout: 'PaginationtDefaultLayout',
        filterLayout: 'BoardFilterNoDateLayout'
    },
    faqCreate: {
        optionLayouts: ['BoardInputLayout'],
    },
    faqUpdate: {
        optionLayouts: ['BoardInputLayout'],
    },
    refund: {
        listLayout: 'BoardListRefundLayout',
        paginationLayout: 'PaginationtNoDeleteLayout',
        filterLayout: 'BoardFilterRefundLayout'
    },
    refundAnswer: {
        optionLayouts: ['BoardInfoLayout', 'BoardAnswerInputLayout'],
    },
    qa: {
        listLayout: 'BoardListQaLayout',
        paginationLayout: 'PaginationtNoDeleteLayout',
        filterLayout: 'BoardFilterQaLayout'
    },
    qaAnswer: {
        optionLayouts: ['BoardQaInfoLayout', 'BoardQaAnswerInputLayout'],
    },
    feedback: {
        listLayout: 'BoardListQaLayout',
        paginationLayout: 'PaginationtNoDeleteLayout',
        filterLayout: 'BoardFilterQaLayout'
    },
    feedbackAnswer: {
        optionLayouts: ['BoardQaInfoLayout', 'BoardQaAnswerInputLayout'],
    },
    cafeNotice:{
        listLayout: 'BoardListCafeNoticeLayout',
        paginationLayout: 'PaginationtDefaultLayout',
        filterLayout: 'BoardFilterCafeNoticeLayout'
    },
    cafeNoticeDetail: {
        detailLayout : 'BoardDetailCafeNoticeLayout'
    },
    cafeConfigUpdate: {
        optionLayouts: ['BoardInputCafeConfigLayout']
    },
    jstQna:{
        listLayout: 'BoardListJstQnaLayout',
        paginationLayout: 'PaginationtNoDeleteLayout',
        filterLayout: 'BoardFilterJstQnaLayout',
    },
    jstCreateQna:{
        writeLayouts: ['BoardJstQnaInfoLayout', 'BoardJstQnaAnswerInputLayout'],
    },
    jstNotice:{
        listLayout: 'BoardListJstNoticeLayout',
        paginationLayout: 'PaginationtDefaultLayout',
        filterLayout: 'BoardFilterJstNoticeLayout'
    },
    jstCreateNotice: {
        writeLayouts: ['BoardWriteJstNoticeLayout'],
    },
    jstUpdateNotice: {
        writeLayouts: ['BoardWriteJstNoticeLayout'],
    },
    JstFaq:{
        listLayout: 'BoardListJstFaqLayout',
        paginationLayout: 'PaginationtDefaultLayout',
        filterLayout: 'BoardFilterJstFaqLayout',
    },
    jstFaqCreate: {
        writeLayouts:['BoardWriteJstFaqLayout'],
    },
    jstFaqUpdate: {
        writeLayouts:['BoardWriteJstFaqLayout'],
    },
    jstMail: {
        listLayout: 'BoardListJstMailLayout',
        paginationLayout: 'PaginationtNoDeleteLayout',
        filterLayout: 'BoardFilterJstMailLayout',
    },
    jstMailDetail: {
        detailLayout : 'BoardDetailJstMailLayout'

    },
    jstMailSend: {
        writeLayouts:['BoardWriteJstMailLayout'],
    },
}

export default {
    methods: {
        returnBoardTemplateConfig(type) {
            return configBoardTemplate[type];
        }
    }
}
